import { get, isFunction } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { IColumn } from "src/interfaces";
import "./index.scss";

interface IProps {
  columns: IColumn[];
  dataSource?: any[] | null;
  styleHeader?: React.CSSProperties;
  styleTable?: React.CSSProperties;
  rowStyle?: React.CSSProperties;
  rowClick?: (row: any) => void;
}

function NafutelTableComponent({
  columns,
  dataSource,
  styleHeader,
  styleTable,
  rowStyle,
  rowClick,
}: IProps) {
  const { t } = useTranslation();
  const renderDataTd = (row: any, column: IColumn, index: number) => {
    const d = get(row, `${column.dataIndex}`);
    if (column.render) {
      return column.render(row, index);
    }
    return d;
  };

  return (
    <table className="nafutel-table" style={{ ...styleTable }}>
      <thead style={{ height: 48, ...styleHeader }}>
        <tr>
          {columns.map((column, index) => {
            return (
              <td
                key={index}
                style={{
                  ...column.style,
                  textAlign: column.alignCenter ? "center" : "left",
                  height: 48,
                  minWidth: "80px",
                }}
              >
                {column.title}
              </td>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {dataSource?.length ? (
          dataSource?.map((row, key) => {
            return (
              <tr
                key={key}
                style={{ ...rowStyle }}
                onClick={() => {
                  if (rowClick) {
                    rowClick(row);
                  }
                }}
              >
                {columns.map((column, indexx) => {
                  return (
                    <td
                      style={
                        isFunction(column.tdCss)
                          ? { ...column.tdCss(row) }
                          : { ...column.tdCss }
                      }
                      key={indexx}
                    >
                      {renderDataTd(row, column, key + 1)}
                    </td>
                  );
                })}
              </tr>
            );
          })
        ) : (
          <tr>
            <td className="text-center" colSpan={10}>{t("table.no_result")}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default NafutelTableComponent;
